<template>
    <div class="logo">
        <router-link to="/">
            <avideo :srcs="['/assets/logo/logo.webm','/assets/logo/logo.mp4']" poster="/assets/logo/logo.png"/>                
        </router-link>
    </div>
</template>

<script>
export default {
  name: 'Logo'
}
</script>

<style lang="scss">
    .logo {
        padding: $spacer/2 0;

        .avideo, .limage {
            height: 100%;
            background: none;
        }

        video, img {
            display: block;
            height: 100%;
            -webkit-mask-image: -webkit-radial-gradient(white, black);
            -webkit-backface-visibility: hidden;
            -moz-backface-visibility: hidden;
        }
    }
</style>
